<template>
    <v-row style="padding-top: 2px; padding-bottom: 4px;">
        <v-col cols='12' md='3' style="color: green;">
            Resolved: {{this.data.resolved}}
        </v-col>
        <v-col cols='12' md='3' class="info--text">
            Staged: {{this.data.started}}
        </v-col>
        <v-col cols='12' md='3' class="warning--text">
            Conflicts: {{this.data.conflicts}}
        </v-col>
        <v-col cols='12' md='3' class="error--text">
            Fatal Conflicts: {{this.data.serious_conflicts}}
        </v-col>
    </v-row>
</template>
<script>
export default {
    name: 'staging-dashboard-stats',
    props: {
    data: {
      required: true,
      type: Object
    }
  },
}
</script>